import React from 'react';
import {Link} from 'react-router-dom';

let CveRecord = (props) => {

    return (
        <tr>
            <td><Link to={"/cve/" + props.cve.id}>{props.cve.id}</Link></td>            
            <td>{props.cve.severity}</td>
            <td>{props.cve.category}</td>
            <td>{props.cve.productSummary}</td>
            <td>{props.cve.formattedDate}</td>
        </tr>
    )
}

export default CveRecord;